
import { CircleMarker } from "react-leaflet";
import React from "react";

const LeafletMapMarks = (props) => {

  return props.data.map((loc, index) => {
    if (loc.pv_count > 0) {
      return <CircleMarker 
      key={index+"pv"}
      className="data-circle-mb"
      center={loc.latlng}
      fillColor={"#075875"}
      radius={props.sizeScale(loc.pv_count)}
      />
    }
    if (loc.demo_count > 0) {
      return <CircleMarker 
      key={index+"demo"}
      className="data-circle-mb"
      center={loc.latlng}
      fillColor={"#ff833b"}
      radius={props.sizeScale(loc.demo_count)}
      />
    }
    return
  })
};

export default LeafletMapMarks;

